import api from '@/lib/api';

export interface AcceptInviteRequestDto {
  token: string;
  password?: string;
}

export interface AcceptInviteResponseDto {
  success: boolean;
  message: string;
  roleType?: string;
}

export interface VerifyInviteResponseDto {
  valid: boolean;
  isExistingUser: boolean;
  organizationName?: string;
  userEmail?: string;
  requiresPassword: boolean;
  message?: string;
}

class InviteService {
  private readonly baseUrl = '/organization-members';

  async acceptInvite(
    data: AcceptInviteRequestDto
  ): Promise<AcceptInviteResponseDto> {
    const response = await api.post<AcceptInviteResponseDto>(
      `${this.baseUrl}/accept-invite`,
      data
    );
    return response.data;
  }

  async verifyInvite(token: string): Promise<VerifyInviteResponseDto> {
    const response = await api.get<VerifyInviteResponseDto>(
      `${this.baseUrl}/verify-invite/${token}`
    );
    return response.data;
  }
}

export default new InviteService();
